import React, { useState, useEffect, useRef } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import USAimage from '../asstes/images/USA_atlanta_milwaukee.png';
import CanadaImg from '../asstes/images/Canada_himilton.png';
import './SelectCountry.css';

const SelectCountry = () => {
  const navigate = useNavigate();
  const [selectedCountry, setSelectedCountry] = useState(null);
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const dropdownRef = useRef(null);

  /* Close dropdown on outside click */
  useEffect(() => {
    const handler = (e) => {
      if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
        setDropdownOpen(false);
      }
    };
    document.addEventListener('mousedown', handler);
    return () => document.removeEventListener('mousedown', handler);
  }, []);

  const handleCountryChange = (value) => {
    setSelectedCountry(value);
  };

  useEffect(() => {
    if (selectedCountry === 'usa') {
      navigate('/USA/Home');
    } else if (selectedCountry === 'canada') {
      window.location.href = 'https://yugalkunjcanada.org/';
    }
  }, [selectedCountry, navigate]);

  const currentYear = new Date().getFullYear();

  return (
    <div className="yk-sc-page">

      {/* ── Header ── */}
      <header className="yk-sc-header">
        <Link to="/" className="yk-sc-header-logo">
          <img
            src="https://stssevastorage.blob.core.windows.net/ykwebsite/logo.png"
            alt="Yugal Kunj"
          />
        </Link>

        {/* Country / Region dropdown */}
        <div className="yk-sc-nav-wrap" ref={dropdownRef}>
          <button
            className="yk-sc-header-nav"
            onClick={() => setDropdownOpen((o) => !o)}
            aria-haspopup="true"
            aria-expanded={dropdownOpen}
          >
            Country / Region
            <svg
              width="10" height="6" viewBox="0 0 10 6" fill="none"
              style={{ transform: dropdownOpen ? 'rotate(180deg)' : 'none', transition: 'transform 0.2s' }}
            >
              <path d="M1 1l4 4 4-4" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
            </svg>
          </button>

          {dropdownOpen && (
            <div className="yk-sc-dropdown">
              <Link
                to="/USA/Home"
                className="yk-sc-dropdown-item"
                onClick={() => setDropdownOpen(false)}
              >
                &nbsp;United States
              </Link>
              <a
                href="https://yugalkunjcanada.org/"
                className="yk-sc-dropdown-item"
                target="_blank"
                rel="noreferrer"
                onClick={() => setDropdownOpen(false)}
              >
                &nbsp;Canada
              </a>
            </div>
          )}
        </div>
      </header>

      {/* ── Main ── */}
      <main className="yk-sc-main">

        {/* Hero */}
        <div className="yk-sc-hero">
          <h1 className="yk-sc-heading">Choose Your Region</h1>
          <p className="yk-sc-sub">
            Select your country to explore temple activities, events, services, and community programs.
          </p>
        </div>

        {/* Country cards */}
        <div className="yk-sc-cards">

          {/* USA */}
          <label
            className="yk-sc-card"
            htmlFor="sc-usa"
            title="USA Centers: Atlanta and Milwaukee"
          >
            <input
              type="radio"
              id="sc-usa"
              name="country"
              value="usa"
              className="yk-sc-radio"
              checked={selectedCountry === 'usa'}
              onChange={() => handleCountryChange('usa')}
            />
            <div className="yk-sc-map">
              <img src={USAimage} alt="USA map — Atlanta and Milwaukee locations" />
            </div>
            <div className="yk-sc-card-body">
              <div className="yk-sc-country-name">United States</div>
              <div className="yk-sc-country-meta">Atlanta &amp; Milwaukee</div>
              <div className="yk-sc-explore">
                Explore <span className="yk-sc-arrow">→</span>
              </div>
            </div>
          </label>

          {/* Canada */}
          <label
            className="yk-sc-card"
            htmlFor="sc-canada"
            title="Canada Centers: Hamilton and Toronto"
          >
            <input
              type="radio"
              id="sc-canada"
              name="country"
              value="canada"
              className="yk-sc-radio"
              checked={selectedCountry === 'canada'}
              onChange={() => handleCountryChange('canada')}
            />
            <div className="yk-sc-map">
              <img src={CanadaImg} alt="Canada map — Hamilton and Toronto locations" />
            </div>
            <div className="yk-sc-card-body">
              <div className="yk-sc-country-name">Canada</div>
              <div className="yk-sc-country-meta">Hamilton &amp; Toronto</div>
              <div className="yk-sc-explore">
                Explore <span className="yk-sc-arrow">→</span>
              </div>
            </div>
          </label>

        </div>
      </main>

      {/* ── Brand footer strip ── */}
      <footer className="yk-sc-footer">
        <div className="yk-sc-footer-inner">
          <Link to="/" className="yk-sc-footer-logo">
            <img
              src="https://stssevastorage.blob.core.windows.net/ykwebsite/logo.png"
              alt="Yugal Kunj"
            />
          </Link>
          <p className="yk-sc-footer-about">
            Radha Madhav Society is part of the worldwide mission of Jagadguru Kripalu Parishat (JKP), a non-profit organization founded by Jagadguru Shree Kripalu ji Maharaj to provide a deeper understanding of true Hinduism and bring to light the wonderful resources of this eternal religion and its all-encompassing culture.
          </p>
          <p className="yk-sc-footer-copy">Copyrights (c) {currentYear} <Link to="/">Yugal Kunj</Link> All rights reserved.</p>
        </div>
      </footer>

    </div>
  );
};

export default SelectCountry;